import { EventOptions } from "./event-types";

export class Action {
  name: string;
  category?: string;
  payload: unknown;
  type: string;
  __global = true;
  timestamp? = Date.now();

  constructor(action: EventOptions, payload?: unknown) {
    this.name = action.name;
    this.category = action.category || "[Identity]";
    this.type = `${this.category} ${action.name}`;
    Object.assign(this, payload);
  }
}
